import * as Yup from 'yup';

export const moveContactFormSchema = Yup.object().shape({
  contact: Yup.object().shape({
    contactsID: Yup.string().required('Contact is required'),
  }),
  customer: Yup.object().shape({
    customerID: Yup.string().required('Customer is required'),
  }),
  // movedType: Yup.string().required('Type is required'),
  // office: Yup.object().when('movedType', (movedType: any, schema) => {
  //   if (movedType[0] === 'office') {
  //     return schema.shape({
  //       officeID: Yup.string().required('Office is required'),
  //     });
  //   } else {
  //     return schema;
  //   }
  // }),
  // project: Yup.object().when('movedType', (movedType: any, schema) => {
  //   if (movedType[0] === 'project') {
  //     return schema.shape({
  //       projectID: Yup.string().required('Project is required'),
  //     });
  //   } else {
  //     return schema;
  //   }
  // }),
  // unit: Yup.object().when('movedType', (movedType: any, schema) => {
  //   if (movedType[0] === 'unit') {
  //     return schema.shape({
  //       unitID: Yup.string().required('Unit is required'),
  //     });
  //   } else {
  //     return schema;
  //   }
  // }),
});
